import { BrandingIdentity, Page, Spacing } from 'zens-storybook'
import { PropsWithChildren, Suspense } from 'react'
import { StyleSheet, View } from 'react-native'

import { MenuAuth } from '../menu'

const styles = StyleSheet.create({
  container: {
    justifyContent: 'space-between',
    flexDirection: 'row',
    zIndex: 100,
    marginHorizontal: Spacing.XXL,
  },
  left: {
    width: 88,
  },
  branding: {
    marginTop: Spacing.M,
  },
  content: {
    flex: 1,
    marginTop: Spacing.L,
    marginHorizontal: Spacing.L,
  },
  auth: {
    marginTop: Spacing.S,
  },
})

type Props = object

const NoContextLayout = (props: PropsWithChildren<Props>) => {
  return (
    <Page
      top={
        <View style={styles.container}>
          <View style={styles.left} />
          <BrandingIdentity size="M" style={styles.branding} />
          <MenuAuth style={styles.auth} companyId={0} />
        </View>
      }
    >
      <Suspense fallback={null}>
        <View style={styles.content}>{props.children}</View>
      </Suspense>
    </Page>
  )
}

export default NoContextLayout
